import React, { createContext, useState } from 'react';
import sabunMuka from '../../assets/img/sabun-muka/sabun-muka.png';
import sabunBatang from '../../assets/img/sabun-batang/sabun-batang.png';
import kursiPutih from '../../assets/img/kursi-putih/kursi-putih.png';
import dompetCoklat from '../../assets/img/dompet-coklat/dompet-coklat.png';
import kursiHijau from '../../assets/img/sofa-ijo/sofa-ijo.png';
import tasPink from '../../assets/img/tas-pink/tas-pink.png';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [isNavbarCategoryOpen, setIsNavbarCategoryOpen] = useState(false);

  const RecommendationProduct = [
    {
      productTitle: 'Rekomendasi Sepatu Pria Untuk Anda',
      productName: 'Sepatu Yeezy 350 v2 Black',
      selling: '254',
      price: 'Rp. 9.000.000',
      discountPrice: 'Rp. 4.500.000',
      discount: '20% OFF'
    },
    {
      productTitle: 'Rekomendasi Sepatu Pria Untuk Anda',
      productName: 'Sepatu Yeezy 350 v2 Black',
      selling: '254',
      price: 'Rp. 9.000.000',
      discountPrice: 'Rp. 4.500.000',
      discount: '20% OFF'
    },{
      productTitle: 'Rekomendasi Sepatu Pria Untuk Anda',
      productName: 'Sepatu Yeezy 350 v2 Black',
      selling: '254',
      price: 'Rp. 9.000.000',
      discountPrice: 'Rp. 4.500.000',
      discount: '20% OFF'
    },{
      productTitle: 'Rekomendasi Sepatu Pria Untuk Anda',
      productName: 'Sepatu Yeezy 350 v2 Black',
      selling: '254',
      price: 'Rp. 9.000.000',
      discountPrice: 'Rp. 4.500.000',
      discount: '20% OFF'
    },{
      productTitle: 'Rekomendasi Sepatu Pria Untuk Anda',
      productName: 'Sepatu Yeezy 350 v2 Black',
      selling: '254',
      price: 'Rp. 9.000.000',
      discountPrice: 'Rp. 4.500.000',
      discount: '20% OFF'
    },
  ]

  const [isOpenFlashSale, setIsOpenFlashSale] = useState(true);
  var [timerFlashSale, setTimerFlashSale] = useState({
    startTimer:'11/27/2020 07:40:00',
    endTimer:'11/30/2020 19:40:00'
  });

  const todaysPromoProducts = [
    {
      productName: 'White Skin Cream',
      qty: 21,
      discount: '70%',
      discountPrice: '100.000',
      actualPrice: '30.000',
      img: sabunMuka,
      alt: 'sabun muka'
    },
    {
      productName: 'Pink Soap',
      qty: 78,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunBatang,
      alt: 'sabun batang'
    },
    {
      productName: 'Sofa Klasik Putih',
      qty: 1,
      discount: '30%',
      discountPrice: '3.000.000',
      actualPrice: '2.100.000',
      img: kursiPutih,
      alt: 'kursi putih'
    },
    {
      productName: 'Dompet Kulit Pria',
      qty: 3,
      discount: '50%',
      discountPrice: '248.000',
      actualPrice: '124.000',
      img: dompetCoklat,
      alt: 'dompet coklat'
    },
  ]

  const flashSale = [
    {
      productName: 'Pink Soap',
      qty: 78,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunBatang,
      alt: 'sabun batang'
    },
    {
      productName: 'White Skin Cream',
      qty: 21,
      discount: '70%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunMuka,
      alt: 'sabun muka'
    },
    {
      productName: 'Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
    {
      productName: 'Dompet Kulit Pria',
      qty: 3,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: dompetCoklat,
      alt: 'dompet coklat'
    },
    {
      productName: 'Sofa Hijau',
      qty: 1,
      discount: '10%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: kursiHijau,
      alt: 'kursi hijau'
    },
    {
      productName: 'Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
  ]

  const mostPopular = [
    {
      productName: 'White Skin Cream',
      qty: 21,
      discount: '70%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunMuka,
      alt: 'sabun muka'
    },
    {
      productName: 'Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
    {
      productName: 'Dompet Kulit Pria',
      qty: 3,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: dompetCoklat,
      alt: 'dompet coklat'
    },
    {
      productName: 'Sofa Hijau',
      qty: 1,
      discount: '10%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: kursiHijau,
      alt: 'kursi hijau'
    },
    {
      productName: 'Pink Soap',
      qty: 78,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunBatang,
      alt: 'sabun batang'
    },
    {
      productName: 'Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
  ]

  const bestSelling = [
    {
      productName: 'Dompet Kulit Pria',
      qty: 3,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: dompetCoklat,
      alt: 'dompet coklat'
    },
    {
      productName: 'Sofa Hijau',
      qty: 1,
      discount: '10%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: kursiHijau,
      alt: 'kursi hijau'
    },
    {
      productName: 'Pink Soap',
      qty: 78,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunBatang,
      alt: 'sabun batang'
    },
    {
      productName: 'White Skin Cream',
      qty: 21,
      discount: '70%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunMuka,
      alt: 'sabun muka'
    },
    {
      productName: 'Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
    {
      productName: 'Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
    {
      productName: 'Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
  ]

  return (
    <AppContext.Provider value={{timerFlashSale ,isNavbarCategoryOpen, RecommendationProduct,setTimerFlashSale,setIsNavbarCategoryOpen, setIsOpenFlashSale, isOpenFlashSale,todaysPromoProducts, flashSale, mostPopular, bestSelling }}>
      {children}
    </AppContext.Provider>
  )
}
